import { Injectable, inject } from '@angular/core';
import {Actions} from '@ngrx/effects';
import {combineLatestWith, mergeMap, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {LinkBaseEffects} from './link.effect';
import {LinkKnowledgeArticleApiService} from '../services/link-knowledge-article-api.service';
import {LinkKnowledgeApiService} from '@link/services/link-knowledge-api.service';
import {HintService} from '@link/services/link-hints-api.service';
import {LinkActions} from '@link/store/link.actions-type';
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";

@Injectable({
  providedIn: 'root',
})
export class LinkApiEffects extends LinkBaseEffects {
  private knowledgeArticle = inject(LinkKnowledgeArticleApiService);
  private knowledge = inject(LinkKnowledgeApiService);
  private hint = inject(HintService);

  constructor() {
    const actions$ = inject(Actions);
    const store = inject(Store);

    super(store, actions$);
  }

  getKnowledgeArticle(action$: Observable<{ knowledgeArticleId: number }>) {
    return action$.pipe(
      mergeMap((action) =>
        this.knowledgeArticle
          .getKnowledgeArticle(action.knowledgeArticleId)
          .pipe(
            map((response) =>
              LinkActions.getKnowledgeArticleSuccess({
                knowledgeArticle: response,
              })
            )
          )
      )
    );
  }

  getOccurredHints(action$: Observable<{ resourceId: number }>) {
    return action$.pipe(
      combineLatestWith(this.store.select(SharedLoginSelectors.selectLinkResource)),
      mergeMap(([_, resource]) => {
        return this.hint.getResourceDashboard(resource!.resourceId!).pipe(
          map((response) =>
            LinkActions.getProfileDashboardSuccess({
              hints: response.hints ?? [],
              errors: response.errors ?? [],
              consumptions: response.consumptions ?? [],
            })
          )
        );
      })
    );
  }

  getKnowledge(action$: Observable<{}>) {
    return action$.pipe(
      combineLatestWith(this.store.select(SharedLoginSelectors.selectLinkResource)),
      mergeMap(([_, resource]) => {
        return this.knowledge.getResourceKnowledge(resource!.resourceId!).pipe(
          map((response) =>
            LinkActions.getKnowledgeSuccess({
              knowledgeArticles: response,
            })
          )
        );
      })
    );
  }
}
